export default "__VITE_ASSET__Dz8p3UCG__"